<style scoped lang="sass">
@import '../variables'

h3
  position: relative
  padding: 0.3em 0
  margin: 1em 0 0.5em
  &:first-child
    margin-top: 0
  &:before
    position: absolute
    content: ''
    bottom: 0
    left: 0
    width: 2rem
    height: 1px
    background: $colorPrimary
  small
    display: block
    color: #888
    font-weight: 400
    font-size: 0.6em
    text-transform: uppercase

.el-row
  display: flex
  .el-col-12
    & > div
      height: 100%

.invoices-summary
  display: flex
  flex-flow: wrap
  .owed
    flex: 0 0 33.3333%
    text-align: center
    padding: 2rem 0
    .amount
      font-size: 1.6rem
      font-weight: 600
    .type
      color: #888
      font-size: 0.8rem

.requests-list
  display: flex
  flex-flow: wrap
  .requests-item
    flex: 0 0 50%
    padding-top: 1rem
    &:nth-child(1), &:nth-child(2)
      padding-top: 0
    &:nth-child(odd)
      padding-right: 0.5rem
      // .el-card
    &:nth-child(even)
      padding-left: 0.5rem
      // .el-card
      //   margin-left: 0.5rem
    .el-card
      // margin-top: 1rem
      height: 100%
      cursor: pointer
      transition: transform 0.1s ease-in-out
      position: relative
      &:before
        position: absolute
        content: ''
        top: 0
        bottom: 0
        left: 0
        width: 5px
        background: transparent
        transition: background 0.1s ease-in-out
      &:hover
        &:before
          background: $colorPrimary
      &:hover
        transform: scale(1.03)
.view-invoices
  width: 100%
</style>

<template lang="pug">
.main-container
  .view-content
    el-row(:gutter='$rowGutter')

      //- Upcoming orders
      el-col(:span='9')
        el-card
          div(slot='header')
            i.mat-icon assignment_turned_in
            | Upcoming orders
          h3 Today
            small {{ $formatDate(todayDate) }}
          order-mini(v-for='x in upcoming.today', :order='x', key='x.id')
          h3 Tomorrow
            small {{ $formatDate(tomorrowDate) }}
          order-mini(v-for='y in upcoming.tomorrow', :order='y', key='x.id')
          h3 Future Orders
          order-mini(v-for='z in upcoming.future', :order='z', key='x.id', :show-date='true')

      el-col(:span='15')

        //- Invoices
        el-card(v-if='requests')
          div(slot='header')
            i.mat-icon receipt
            | Invoices
          
          .invoices-summary
            .owed
              .amount {{ totalInvoices }}
              .type Total Invoices
            .owed
              .amount {{ $formatCents(totalCards) }}
              .type Credit Card(s)
            .owed
              .amount {{ $formatCents(totalHouse) }}
              .type House account
          el-button(type="primary", @click="viewInvoices", class='view-invoices') View all
        
        //- Open / Pending Requests
        el-card(v-if='requests')
          div(slot='header')
            i.mat-icon assignment
            | Pending requests
          .requests-list
            .requests-item(v-for='x in requests')
              router-link(:to="'/user/requests/' + x.id")
                request-mini(:request='x')
</template>

<script>
import moment from 'moment'
import OrderMini from './blocks/OrderMini.vue'
import RequestMini from './blocks/RequestMini.vue'

function data ( ) {
  let now = new Date()
  let format = 'YYYY-MM-DD'
  let todayDate = moment(now, format)
  let tomorrowDate = moment(new Date((new Date()).setDate(now.getDate()+1)), format)
  return {
    format,
    todayDate,
    tomorrowDate,
    upcoming: {
      today: [],
      tomorrow: [],
      future: [],
    },
    requests: null,
    totalInvoices: 0,
    totalCards: 0,
    totalHouse: 0,
  }
}

function created ( ) {
  this.$simplecater.get('/orders/open').then( ( r ) => {
    let orders = _.chain(r.data.data).sortBy('delivery_time').sortBy('delivery_date').value()
    let todayOrders = _.filter(orders, ( x ) => moment(x.delivery_date, this.format).isSame(this.todayDate, 'day'))
    let tomorrowOrders = _.filter(orders, ( x ) => {
      return moment(x.delivery_date, this.format).isSame(this.tomorrowDate, 'day')
    })
    let futureOrders = _.filter(orders, ( x ) => (!moment(x.delivery_date, this.format).isSame(this.todayDate, 'day') && !moment(x.delivery_date, this.format).isSame(this.tomorrowDate, 'day')))
    this.upcoming = {
      today: todayOrders,
      tomorrow: tomorrowOrders,
      future: futureOrders
    }
  })

  this.$simplecater.get('/requests/open').then( ( r ) => {
    this.requests = _.sortBy(r.data.data, 'delivery_date')
  })

  this.$simplecater.get('/invoices/open').then( ( r ) => {
    let invoices = r.data.data
    this.totalCards = _.reduce(_.filter(invoices, ( i ) => (i.payment_source !== 'OFFLINE')), ( acc, i ) => (acc + i.total_cents), 0)
    this.totalHouse = _.reduce(_.filter(invoices, { payment_source: 'OFFLINE'}), ( acc, i ) => (acc + i.total_cents), 0)
    this.totalInvoices = invoices.length
  })
}

let methods = {
  viewInvoices ( ) {
    this.$router.push('/user/billing')
  }
}

let components = { OrderMini, RequestMini }

export default { data, methods, created, components }

</script>


// WEBPACK FOOTER //
// src/user/Overview.vue